import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import VideoPlayerCoreWithContext from "./VideoPlayerCore";

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren, extra) {
    var props, childrenNode, reactifiedChildren;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            props = {
              autoplayInModal: domNode.getAttribute("data-autoplay-in-modal") === "true" || false,
              duration: domNode.getAttribute("data-duration"),
              gatedCookieName: domNode.getAttribute("data-gated-cookie-name"),
              gatedFormContentLocation: domNode.getAttribute("data-gated-form-content-location"),
              gatedFormId: domNode.getAttribute("data-gated-form-id"),
              videoId: domNode.getAttribute("data-video-id"),
              kind: domNode.getAttribute("data-kind"),
              playLabel: domNode.getAttribute("data-play-label"),
              name: domNode.getAttribute("data-video-name"),
              thumbnailUrl: domNode.getAttribute("data-thumbnail-url"),
              description: domNode.getAttribute("data-description"),
              uploadDate: domNode.getAttribute("data-upload-date"),
              analytics: extra.analytics,
              reactFromMarkupRehydrators: extra.rehydrators,
              reactFromMarkupOptions: {
                extra: extra
              },
              isRehydrating: true
            };
            childrenNode = domNode.querySelector("[data-rehydratable-children]");
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            return _context.abrupt("return", /*#__PURE__*/React.createElement(VideoPlayerCoreWithContext, props, reactifiedChildren));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;